import React from 'react';

export const useDragDrop = () => {
    const copy = (input: any[]) => {
        return Object.assign([], input)
    }

    const List = React.useRef([])
    const ListMem = React.useRef([])
    const dragInd = React.useRef(-1)
    const dropInd = React.useRef(-1)
    const dropped = React.useRef(false)

    const InitData = (list: any, listMem?: any) => {
        List.current = copy(list)
        if (listMem) ListMem.current = copy(listMem)
    }

    const onDragStart = (ind: number) => () => {
        dragInd.current = ind;
    }

    const onDragOver = (event: any) => {
        event.preventDefault();
    }

    const onDragEnter = (ind: number) => (): any => {
        dropInd.current = ind;
    }


    const onDragEnd = (droppedCb: any) => () => {
        const init = () => {
            dropped.current = false
            dragInd.current = -1
        }
        if (dropped.current) {
            arrayMoveMutate(List.current, dragInd.current, dropInd.current)
            arrayMoveMutate(ListMem.current, dragInd.current, dropInd.current)
            droppedCb(List.current, ListMem.current)
            init()
        } else {
            droppedCb(null)
            init()
        }
    }

    const onDrop = () => {
        dropped.current = true
    }

    const arrayMoveMutate = (array: any[], from: number, to: number) => {
        const startIndex = from < 0 ? array.length + from : from;
    
        if (startIndex >= 0 && startIndex < array.length) {
            const endIndex = to < 0 ? array.length + to : to;
    
            const [item] = array.splice(from, 1);
            array.splice(endIndex, 0, item);
        }
    };
    
    // const arrayMove = (array: any[], from: number, to: number): any => {
    //     array = [...array];
    //     arrayMoveMutate(array, from, to);
    //     return array;
    // };
    
    return { InitData, onDragStart, onDragOver, onDragEnter, onDragEnd, onDrop }

}